

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation
} from "react-router-dom";




import truckImg from '../../assets/product/truck.png'
import sevenImg from '../../assets/product/7-11.png'
import familyMartImg from '../../assets/product/familyMart.png'
import hilifeImg from '../../assets/product/Hi-Life.png'
import OKImg from '../../assets/product/OK.png'


import { separatorNumber, useGlobalFunc } from "../../global/constants.js";
import UserApi from "../../services/UserApi.jsx";

import LightBox from "../../compontents/LightBox.js";
import PathLocation from "../../compontents/PathLocation.js";

import CountBtn from "../../compontents/CountBtn.js";
import LoginDialog from "./compontents/LoginDialog";
import { useSelector } from "react-redux";


import Tag from "../../compontents/Tag";

const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const userInfo = useSelector(state => state.userInfo);


    const [itemId, setItemId] = useState(0)
    const [isPhysical, setIsPhysical] = useState(false)

    const { setLoading, successToast, errorToast, updateMe } = useGlobalFunc()

    const [data, setData] = useState(null)
    const [dataList, setDataList] = useState(null)

    const [count, setCount] = useState(0)

    const [detailIndex, setDetailIndex] = useState(0)

    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');

    const handleOpen = (value) => {
        console.log(value)
        setSelectedValue(value)
        setOpen(true);
    };

    const handleClose = (value, type) => {
        setOpen(false);
    };




    async function getData(id) {
        setLoading(true)
        try {
            let res = await UserApi.productGet({ id: id })
            console.log(res.data.data)
            setData(res.data.data)

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)
    }

    async function addCart() {
        if (userInfo && userInfo.shoppingPoints > 0 && !data.isShoppingPointPackage) {
            errorToast('請先使用購物金購買套組')
            return
        }
        setLoading(true)
        try {
            let res = await UserApi.cartAdd({ "id": itemId, quantity: count })
            console.log(res.data.data)
            successToast(t('addCart Success'))
        }
        catch (errors) {
            handleOpen()
            //errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)
    }



    useEffect(() => {
        let id = location.pathname.substring(location.pathname.lastIndexOf('/') + 1)
        setItemId(id)
        getData(id)
        setCount(1)
        if (localStorage.getItem('userToken')) {
            updateMe()
        }

        const typeValue = query.get('type');
        console.log(typeValue)
        // if (typeValue == 'physical') {
        //     setIsPhysical(true)
        //     getPhysicalData(id)
        // }
        // else {
        //     getData(id)
        //     getDataList({ page: 1 })
        // }
    }, [location.pathname.substring(location.pathname.lastIndexOf('/') + 1)]);


    return <div className="relative w-full">
        <div className="session1 bg-white pt-10  pb-20" >
            <PathLocation />

            {
                data != null ?
                    <div className="mt-12">
                        <div className="w-full flex justify-between flex-wrap ">
                            <div className="w-full  md:w-[48%] mb-4 md:mb-0">
                                {
                                    data.images.length > 0 ?
                                        <LightBox images={data.images} currentIndex={0} />
                                        :
                                        <div className="w-full aspect-[1/1] bg-black2 rounded-xl">
                                        </div>
                                }
                            </div>

                            <div className="w-full md:w-[48%]    text-black6 text-base flex  ">

                                <div className="pt-[6px] pb-28">
                                    <div className="text-black08">

                                        <p className="text-sm font-medium mb-2">{data.category.name}</p>
                                        <div className="flex flex-wrap gap-2 items-center ">

                                            {
                                                !data.isDiscount &&
                                                <Tag className="" title="不打折" />
                                            }
                                            {
                                                data.isShoppingPointPackage &&
                                                <Tag className="" title="購物金商品" />
                                            }

                                        </div>


                                        <p className="text-2xl font-semibold mb-3 mt-3">{data.name}</p>
                                        {/* <p className="text-sm mb-4">產品編號：{data.id}</p> */}
                                        <div className="mb-3" dangerouslySetInnerHTML={{ "__html": data.shortDescription }} ></div>


                                        <p className="mb-[75px] text-xl text-main3 font-bold">NT${separatorNumber(data.price)}</p>

                                        <div className=" flex items-center gap-4 hidden">
                                            配送:
                                            {
                                                [truckImg, sevenImg, familyMartImg, hilifeImg, OKImg].map(i =>
                                                    <img className="w-7 object-contain" src={i} />)

                                            }
                                        </div>


                                    </div>

                                    {
                                        data.lotNumber && <p className="text-2xl text-black8 font-semibold">Lot .{data.lotNumber}</p>
                                    }
                                    <p className="text-black9 font-semibold text-3xl mt-8 mb-4">{data.collectionName}</p>
                                    <p>{data.artistName}</p>

                                    <div className="flex">

                                    </div>

                                    <div className="hidden md:block">
                                        <CountBtn count={count} setCount={setCount} />
                                        <button onClick={() => addCart()} className=" mt-4 w-full py-2 text-sm font-semibold  text-white rounded-full bg-main3 ">加入購物車</button>
                                    </div>

                                </div>


                            </div>


                        </div>

                        <div className=" flex  mt-10 w-full border-solid border-black4 border-b">
                            {
                                ['產品詳情', 'Q&A', '更多'].map((i, index) => <div onClick={() => setDetailIndex(index)} className={`${index == detailIndex ? "text-brown1 font-bold " : " text-[#B2B2B2]"}  relative w-28 cursor-pointer`}>
                                    <p className="text-center mb-3">{i}</p>
                                    {
                                        index == detailIndex && <div className=" absolute bottom-0 left-0 w-full h-1 bg-brown1 rounded-t-full"></div>
                                    }

                                </div>)
                            }
                        </div>

                        <div className="text-black9 md:px-10 py-10 ">


                            <div dangerouslySetInnerHTML={{ "__html": detailIndex == 0 ? data.description : detailIndex == 1 ? data.qa : data.moreDetails }} ></div>

                        </div>


                    </div>


                    : ""
            }


        </div >
        <div className="md:hidden fixed bottom-0 left-0 w-full flex">
            <div className="w-1/3 min-w-[150px] flex-none">
                <CountBtn count={count} setCount={setCount} />
            </div>
            <button onClick={() => addCart()} className="w-2/3 py-2 text-sm font-semibold  text-white bg-main3 ">加入購物車</button>

        </div>

        <LoginDialog
            selectedValue={selectedValue}
            open={open}
            onClose={handleClose} />
    </div>
}

export default Home